import React from 'react';

const AboutAmet = () => {
    return (
        <div className="mt-5"> 
            <h3 data-aos="fade-up" data-aos-duration="2000">
                Amet minim mollit non deserunt <br />
                <span style={{ color: '#ff3465' }}>ullamco est sit</span> aliqua dolor do amet sint
            </h3>
            <div className="row mt-4">
                <div className="col-md-4">
                    <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder"
                        style={{ color: '#ff3465', height: 80, width: 80, padding: 15, borderRadius: '50%', border: '5px dotted gray' }}
                    >01</h1>
                    <h5 data-aos="fade-up" data-aos-duration="2000">Amet minim mollit non</h5>
                    <p data-aos="fade-up" data-aos-duration="3000" style={{ textAlign: 'justify' }}>Morbi accumsan cras feugiat euismod suspendisse purusivu. Laoreet mi leo id pretium.</p>
                </div>
                <div className="col-md-4">
                    <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder"
                        style={{ color: '#ff3465', height: 80, width: 80, padding: 15, borderRadius: '50%', border: '5px dotted gray' }}
                    >02</h1>
                    <h5 data-aos="fade-up" data-aos-duration="2000">Porta tempus duis purus</h5>
                    <p data-aos="fade-up" data-aos-duration="3000" style={{ textAlign: 'justify' }}>Conubia ultricies neque elit nam praesent aptent mauris vel laoreet auctor aliquam curae.</p>
                </div>
                <div className="col-md-4">
                    <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder"
                        style={{ color: '#ff3465', height: 80, width: 80, padding: 15, borderRadius: '50%', border: '5px dotted gray' }}
                    >03</h1>
                    <h5 data-aos="fade-up" data-aos-duration="2000">Platea enim fermentum</h5>
                    <p data-aos="fade-up" data-aos-duration="3000"style={{ textAlign: 'justify' }}>Viverra aliquam orci etiam sodales inceptos curae lobortis primis fermentum consectetur curae.</p>
                </div>
            </div>
        </div>
    );
};

export default AboutAmet;